<iq-central-front-end-navbar></iq-central-front-end-navbar>
<section class="hidden">
  <section class="row upload-color">
    <div class="col-lg-4 col-md-3 col-sm-12 pr-0">
      <div class="upload-progress-section">
        <div class="text-center">
          <div *ngIf="filePath">
            <ngx-extended-pdf-viewer
              [src]="filePath"
              [textLayer]="true"
              [showHandToolButton]="true"
              [showDownloadButton]="true"
              height="600px"
              [locale]="'en-GB'"
            >
            </ngx-extended-pdf-viewer>
          </div>
          <div
            (click)="openFileInput()"
            ng2FileDrop
            *ngIf="!url && !go"
            [ngClass]="{ 'nv-file-over': hasBaseDropZoneOver }"
            [uploader]="uploader"
            class="p-5 add-color"
            id="dropbox"
          >
            <img
              src="assets/images/add.png"
              alt="Add"
              class="py-5 mt-0 click"
            />
          </div>
          <div *ngIf="go && !url" class="text-center p-5 container">
            <h1 class="font48 text-white">{{ uploadProgress }}%</h1>
            <!-- <p class="my-4 font18 text-grey">{{ file.name }}</p> -->
            <p class="font18 text-grey">PROCESSING<br />00:00 LEFT...</p>
          </div>
          <div class="m-5 d-flex justify-content-between">
            <label for="file" class="btn btn-secondary btn-md mr-3 pt-2"
              >UPLOAD</label
            >
            <input
              type="file"
              id="file"
              #fileInput
              ng2FileSelect
              [style.display]="'none'"
              [uploader]="uploader"
              (change)="fileInput.value = ''"
              [ngClass]="{
                'is-invalid': requiredFileType
              }"
            />
            <span class="text-white font14"
              >OR DRAG AND DROP<br />
              PDF HERE</span
            >
          </div>
          <div class="text-red m-0 p-0 font18" *ngIf="requiredFileType">
            Only *pdf is allowed
          </div>
        </div>
        <div class="mt-auto container font14 text-grey">
          Allowed formats: *PDF
        </div>
      </div>
    </div>
    <div class="col-lg-8 col-md-3 col-sm-12 bg-white">
      <div class="container mt-5" [formGroup]="contentForm">
        <div class="mb-4 font24 text-grey cursor-pointer" (click)="goBack()">
          <i class="fa fa-arrow-left mr-3"></i> Back
        </div>

        <p class="mb-2 font24 text-grey">Content Title</p>
        <textarea
          placeholder="Enter content title"
          formControlName="name"
          class="change-name-textarea form-control"
          [ngClass]="{
            'is-invalid':
              contentForm.get('name').errors && contentForm.get('name').touched
          }"
        ></textarea>
        <div class="invalid-feedback mt-0 p-0">Please enter content title</div>
        <p class="mb-3 font24 text-grey">Content Description</p>
        <angular-editor
          [placeholder]="'Enter text here...'"
          [config]="config"
          formControlName="description"
          [ngClass]="{
            'is-invalid':
              contentForm.get('description').errors &&
              contentForm.get('description').touched
          }"
        ></angular-editor>
        <div class="invalid-feedback mt-0 p-0">
          Please describe this content
        </div>
        <span class="font14 font-light text-grey">
          Let participants know a little about this content in 500 characters or
          less.
        </span>
        <div class="d-flex justify-content-end">
          <button
            [disabled]="contentForm.invalid || !url"
            class="btn btn-outline-secondary btn-sm my-5 mr-3"
            (click)="addMoreContent('path')"
          >
            Save and add more
          </button>
          <button
            class="btn btn-secondary btn-md my-5"
            (click)="finish()"
            [disabled]="contentForm.invalid || !url"
          >
            Finish
          </button>
        </div>
      </div>
    </div>
  </section>
</section>
